// Framework and third-party non-UI
import React, { useContext } from 'react';

// Redux, contexts, and local helpers/utils/modules
import { DataGridContext } from './DataGrid';

// Component specific modules (Component-styled, etc.)
import { StyledDataGridCell } from './DataGrid-styled';

// App components

// Third-party components (buttons, icons, etc.)

interface DataGridCellProps {
  colSpan?: number;
  style?: React.CSSProperties;
}

const DataGridCell: React.FC<DataGridCellProps> = ({
  children,
  colSpan,
  style,
  ...other
}) => {
  const dataGridContext = useContext(DataGridContext);
  return (
    <StyledDataGridCell
      {...dataGridContext}
      colSpan={colSpan}
      style={style}
      {...other}
    >
      {children}
    </StyledDataGridCell>
  );
};

export default DataGridCell;
